import * as angular from "angular";
import {IController} from "angular";

export class AgentMultipleSkillSelectCtrl implements IController {

  skills: any;
  agentType: any;
  options: any;
  isDisabled: any;
  ngRequired: any;
  ngPlaceholder: any;

  onChange: Function;

  private skillsByType: any;
  private selectOptions: any;

  constructor(private agentConstants, private $mdSelect) {
  }

  $onInit() {
    this.skillsByType = this.agentConstants.skillsByType;
    this._setOptions();
  }

  $onChanges(changes) {
    if (changes.agentType && !changes.agentType.isFirstChange()) {
      this._setOptions()
    }
    if (changes.options && !changes.options.isFirstChange()) {
      this._setOptions()
    }
  };

  reset() {
    this.onChange({skills: undefined});
    this.$mdSelect.hide();
  }

  cancel() {
    this.$mdSelect.hide();
  }

  select() {
    this.onChange({skills: this.skills});
    this.$mdSelect.hide();
  }

  private _setOptions() {
    this.selectOptions = this.options || this.skillsByType[this.agentType];
  }


}

angular
  .module('bringoz.admin.agents')
  .component('agentMultipleSkillSelect', {
    bindings: {
      skills: '<',
      agentType: '<',
      options: '<?',
      isDisabled: '<?',
      ngRequired: '@?',
      ngPlaceholder: '@?',
      onChange: '&'
    },
    template: require('./agent-multiple-skill-select.html').default,
    controller: AgentMultipleSkillSelectCtrl
  });
